import styled from '@emotion/styled';
import { flexbox, layout } from 'styled-system';

import Icon from '../../components/Icon';
import BaseBox from '../../internal/components/BaseBox';

const Col = styled(BaseBox)(flexbox, layout, {
  [`> ${Icon}`]: {
    display: 'block',
  },
});

export default Col;
